import { Box, Tab, Tabs, Hidden } from '@mui/material';
import styles from './Tabs.module.scss';
import React from 'react';
import NestedSelect from '../NestedSelect';
import { useSearchParams } from 'react-router-dom';

const TabSelect = ({
  options,
  setActiveTab,
  activeTab,
  setActiveChildTab,
  activeChildTab,
  disableChildTab = false,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const selectDropdownItem = (index) => {
    setActiveTab(index);
    const activeTabName = options[index]?.name;
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('activeTab', activeTabName);
    if (options[index].child.length) {
      setActiveChildTab(0);
      const activeChildTabName = options[index]?.child[0]?.name;
      newSearchParams.set('activeChildTab', activeChildTabName);
    } else {
      setActiveChildTab(0);
      newSearchParams.delete('activeChildTab');
    }

    setSearchParams(newSearchParams);
  };

  const changeChildTab = (index) => {
    setActiveChildTab(index);
    const activeChildTabName = options[activeTab].child[index].name;
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('activeChildTab', activeChildTabName);
    setSearchParams(newSearchParams);
  };

  return (
    <Box>
      <Box className={styles.tabsContainer}>
        <Hidden mdDown>
          <Box
            className={`${styles.tabs} ${
              options[activeTab].child && options[activeTab].child.length ? styles.parentTabs : null
            }`}
          >
            <Tabs
              TabIndicatorProps={{ style: { backgroundColor: '#143471' } }}
              value={activeTab}
              onChange={(event, value) => selectDropdownItem(value)}
            >
              {options.map((tab, index) => (
                <Tab
                  key={tab.name}
                  className={`${styles.tabsItem} ${
                    activeTab === index ? styles.tabsItemActive : null
                  }`}
                  label={tab.name}
                />
              ))}
            </Tabs>
          </Box>
          {options[activeTab].child && options[activeTab].child.length ? (
            <Box className={styles.tabs}>
              <Tabs
                TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                value={activeChildTab}
                onChange={(event, value) => changeChildTab(value)}
              >
                {options[activeTab].child.map((tab, index) => (
                  <Tab
                    key={tab.name}
                    className={`${styles.tabsItem} ${
                      activeChildTab === index
                        ? styles.tabsItemActive
                        : disableChildTab && activeChildTab !== index
                          ? styles.tabsItemDisabled
                          : null
                    }`}
                    disabled={disableChildTab && activeChildTab !== index}
                    label={tab.name}
                  />
                ))}
              </Tabs>
            </Box>
          ) : null}
        </Hidden>
      </Box>
      <Hidden mdUp style={{ width: '100%' }}>
        <NestedSelect
          options={options}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
          setActiveChildTab={setActiveChildTab}
          activeChildTab={activeChildTab}
        />
      </Hidden>
    </Box>
  );
};
export default TabSelect;
